import { render, staticRenderFns } from "./userRiskConf.vue?vue&type=template&id=72329684&scoped=true"
import script from "./userRiskConf.vue?vue&type=script&lang=ts"
export * from "./userRiskConf.vue?vue&type=script&lang=ts"
import style0 from "./userRiskConf.vue?vue&type=style&index=0&id=72329684&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72329684",
  null
  
)

export default component.exports